/**
 * Analytics utilities for Google Analytics and Facebook Pixel
 */

// Declare global types for analytics functions
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    fbq?: (...args: any[]) => void;
  }
}

/**
 * Track event with Google Analytics
 */
export const trackGAEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  } else {
    console.warn('Google Analytics not loaded');
  }
};

/**
 * Track event with Facebook Pixel
 */
export const trackFBEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, eventParams);
  } else {
    console.warn('Facebook Pixel not loaded');
  }
};

/**
 * Track event with both Google Analytics and Facebook Pixel
 */
export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  trackGAEvent(eventName, eventParams);
  trackFBEvent(eventName, eventParams);
};

/**
 * Pre-defined tracking events for common actions
 */
export const AnalyticsEvents = {
  SIGNUP_STARTED: 'signup_started',
  SIGNUP_COMPLETED: 'signup_completed',
  LOGIN_STARTED: 'login_started',
  WORKSPACE_CREATED: 'workspace_created',
  INVITE_SENT: 'invite_sent',
  SUBSCRIPTION_STARTED: 'subscription_started',
  SUBSCRIPTION_COMPLETED: 'subscription_completed',
  // Onboarding funnel — use to spot drop-off in GA4 funnels
  ONBOARDING_WIZARD_STEP: 'onboarding_wizard_step',
  ONBOARDING_CHECKLIST_STEP: 'onboarding_checklist_step',
  ONBOARDING_TOUR_STARTED: 'onboarding_tour_started',
  ONBOARDING_TOUR_COMPLETED: 'onboarding_tour_completed',
  ONBOARDING_TOUR_ABANDONED: 'onboarding_tour_abandoned',
} as const;
